<template>
  <div>
    <header-component />
    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="flex justify-between items-center p-2">
          <div>
            <h3
              class="mb-0 w-full font-bold text-gray-800 text-md"
              style="text-transform: capitalize"
            >
              Vendors List
            </h3>
          </div>
          <div class="flex items-center">
            <base-button size="sm" type="primary" @click="createVendor"
              >Add New</base-button
            >
          </div>
        </div>

        <div class="overflow-x-auto">
          <table class="min-w-full bg-white border border-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  class="px-2 py-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                  style="min-width: 180px;"
                >
                  Name
                </th>
                <th
                  class="px-2 py-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Gender
                </th>
                <th
                  class="px-2 py-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Email
                </th>
                <th
                  class="px-2 py-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Phone
                </th>
                <th
                  class="px-2 py-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Type
                </th>
                <th
                  class="px-2 py-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Active Status
                </th>
                <th
                  class="px-2 py-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Actions
                </th>
              </tr>
              <!-- Filter Row -->
              <tr class="bg-gray-100">
                <th class="px-1 py-2 border-b">
                  <input
                    v-model="columnFilters.name"
                    type="text"
                    placeholder="Search name..."
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-1 py-2 border-b">
                  <select
                    v-model="columnFilters.gender"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @change="onColumnFilterChange"
                  >
                    <option value="">All</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </th>
                <th class="px-1 py-2 border-b">
                  <input
                    v-model="columnFilters.email"
                    type="text"
                    placeholder="Search email..."
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-1 py-2 border-b">
                  <input
                    v-model="columnFilters.phone"
                    type="text"
                    placeholder="Search phone..."
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-1 py-2 border-b">
                  <select
                    v-model="columnFilters.serviceCategoryId"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @change="onColumnFilterChange"
                  >
                    <option value="">All Types</option>
                    <option
                      v-for="category in serviceCategoryList"
                      :key="category.serviceCategoryId"
                      :value="category.serviceCategoryId"
                    >
                      {{ category.label }}
                    </option>
                  </select>
                </th>
                <th class="px-1 py-2 border-b">
                  <select
                    v-model="columnFilters.isActive"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @change="onColumnFilterChange"
                  >
                    <option value="">All</option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </th>
                <th class="px-1 py-2 border-b">
                  <button
                    type="button"
                    @click="clearColumnFilters"
                    class="px-2 py-1 w-full text-xs text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-1 focus:ring-red-500"
                  >
                    Clear
                  </button>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr
                v-for="vendor in vendorList"
                :key="vendor.vendorId"
                class="hover:bg-gray-50"
              >
                <td class="px-2 py-2 text-sm text-gray-900 border-b">
                  <div class="break-words">
                    {{ vendor.firstName }} {{ vendor.lastName }}
                  </div>
                  <div
                    v-if="vendor.firmName"
                    class="mt-0.5 text-xs text-gray-500 break-words"
                  >
                    {{ vendor.firmName }}
                  </div>
                </td>
                <td
                  class="px-2 py-2 text-sm text-gray-900 whitespace-nowrap border-b capitalize"
                >
                  {{ vendor.gender || "-" }}
                </td>
                <td class="px-2 py-2 text-sm text-gray-900 border-b">
                  <div class="break-words">{{ vendor.email || "-" }}</div>
                </td>
                <td
                  class="px-2 py-2 text-sm text-gray-900 whitespace-nowrap border-b"
                >
                  {{ vendor.phone || "-" }}
                </td>
                <td class="px-2 py-2 text-sm text-gray-900 border-b">
                  <div class="break-words">
                    {{
                      (vendor.serviceCategory &&
                        vendor.serviceCategory.label) ||
                        "-"
                    }}
                  </div>
                </td>
                <td
                  class="px-2 py-2 text-sm whitespace-nowrap border-b"
                >
                  <span
                    class="inline-flex px-2 py-1 text-xs font-semibold rounded-full"
                    :class="
                      vendor.isActive === false
                        ? 'bg-red-100 text-red-800'
                        : 'bg-green-100 text-green-800'
                    "
                  >
                    {{ vendor.isActive === false ? "Inactive" : "Active" }}
                  </span>
                </td>
                <td
                  class="px-2 py-2 text-sm text-gray-900 whitespace-nowrap border-b"
                >
                  <div class="relative inline-block text-left">
                    <button
                      @click="toggleDropdown(vendor.vendorId)"
                      class="inline-flex justify-center px-3 py-1.5 text-xs font-medium text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      Actions
                      <svg
                        class="w-3 h-3 ml-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                    <div
                      v-if="activeDropdown === vendor.vendorId"
                      class="absolute right-0 z-20 w-44 mt-1 origin-top-right bg-white rounded-md border border-gray-200 shadow-lg"
                    >
                      <div class="py-1">
                        <button
                          @click="handleAction(vendor, 'edit')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Edit
                        </button>
                        <button
                          @click="handleAction(vendor, 'changePassword')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Change Password
                        </button>
                        <button
                          @click="handleAction(vendor, 'showPoints')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Show Points
                        </button>
                        <button
                          @click="handleAction(vendor, 'showLabors')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Show All Labors
                        </button>
                        <button
                          @click="handleAction(vendor, 'reports')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Reports
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!vendorList || vendorList.length === 0">
                <td
                  colspan="7"
                  class="px-2 py-4 text-sm text-center text-gray-500 border-b"
                >
                  No vendors found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <el-dialog title="Add Vendor" :visible.sync="addVendor">
        <add-vendor @close="addVendor = false" />
      </el-dialog>
      <el-dialog
        title="Change Password"
        :visible.sync="changePasswordModal"
        width="30%"
      >
        <change-password @close="changePasswordModal = false" />
      </el-dialog>
      <el-dialog
        v-if="selectedVendor"
        :title="
          'Show Monthwise Points of ' +
            selectedVendor.firstName +
            ' ' +
            selectedVendor.lastName
        "
        :visible.sync="showPoints"
      >
        <div>
          <el-table
            class="table-responsive table-flush"
            header-row-class-name="thead-light"
            :data="pointList"
          >
            <el-table-column label="Month">
              <template slot-scope="scope">{{ scope.row.title }}</template>
            </el-table-column>
            <el-table-column label="Total Service Requests">
              <template slot-scope="scope">{{ scope.row.count }}</template>
            </el-table-column>
            <el-table-column label="Average Points">
              <template slot-scope="scope">{{ scope.row.points }}</template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Dialog, Button } from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddVendor from "./AddVendor";
import headerComponent from "../Components/HeaderComponent";
import changePassword from "./changePassword.vue";

export default {
  data: () => {
    return {
      addVendor: false,
      changePasswordModal: false,
      showPoints: false,
      points: 0,
      pointList: [],
      selectedVendor: null,
      activeDropdown: null,
      filterTimeout: null,
      columnFilters: {
        name: "",
        gender: "",
        email: "",
        phone: "",
        serviceCategoryId: "",
        isActive: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      vendor: "vendor/getVendor",
      vendorList: "vendor/getVendorList",
      serviceCategoryList: "serviceCategory/getServiceCategoryList"
    })
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "add-vendor": AddVendor,
    "header-component": headerComponent,
    "change-password": changePassword
  },
  mounted() {
    this.getServiceCategoryList();
    this.applyColumnFilters();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    clearTimeout(this.filterTimeout);
  },
  methods: {
    ...mapActions({
      getVendorList: "vendor/getVendorList",
      fetchVendor: "vendor/fetchVendor",
      getVendorMonthwisePoints: "vendor/getVendorMonthwisePoints",
      getServiceCategoryList: "serviceCategory/getServiceCategoryList"
    }),
    ...mapMutations({
      setVendor: "vendor/setVendor",
      resetVendor: "vendor/resetVendor"
    }),
    handleClickOutside(event) {
      if (!event.target.closest(".relative")) {
        this.activeDropdown = null;
      }
    },
    toggleDropdown(vendorId) {
      this.activeDropdown =
        this.activeDropdown === vendorId ? null : vendorId;
    },
    buildFilterParams() {
      const params = {};
      if (this.columnFilters.name) {
        params.name = this.columnFilters.name;
      }
      if (this.columnFilters.gender) {
        params.gender = this.columnFilters.gender;
      }
      if (this.columnFilters.email) {
        params.email = this.columnFilters.email;
      }
      if (this.columnFilters.phone) {
        params.phone = this.columnFilters.phone;
      }
      if (this.columnFilters.serviceCategoryId) {
        params.serviceCategoryId = this.columnFilters.serviceCategoryId;
      }
      if (this.columnFilters.isActive !== "") {
        params.isActive = this.columnFilters.isActive;
      }
      return params;
    },
    onColumnFilterChange() {
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.applyColumnFilters();
      }, 300);
    },
    applyColumnFilters() {
      this.getVendorList(this.buildFilterParams());
    },
    clearColumnFilters() {
      clearTimeout(this.filterTimeout);
      this.filterTimeout = null;
      this.columnFilters = {
        name: "",
        gender: "",
        email: "",
        phone: "",
        serviceCategoryId: "",
        isActive: ""
      };
      this.applyColumnFilters();
    },
    handleAction(vendor, command) {
      this.activeDropdown = null;
      if (command === "edit") {
        this.fetchVendor(vendor.vendorId).then(res => {
          this.$router.push(`/vendors/${vendor.vendorId}/edit`);
          this.setVendor(res);
        });
      } else if (command === "changePassword") {
        this.setVendor(vendor);
        this.changePasswordModal = true;
      } else if (command === "showPoints") {
        this.selectedVendor = vendor;
        this.getVendorPoints(vendor.vendorId);
      } else if (command === "showLabors") {
        this.getVendorPoints(vendor.vendorId);
        this.$router.push("/vendors/" + vendor.vendorId + "/labors");
      } else if (command === "reports") {
        const name = `${vendor.firstName} ${vendor.lastName}`.trim();
        this.$router.push({
          path: `/vendors/${vendor.vendorId}/reports`,
          query: { name }
        });
      }
    },
    async getVendorPoints(vendorId) {
      this.getVendorMonthwisePoints({
        vendorId
      }).then(res => {
        this.pointList = res;
        this.showPoints = true;
      });
    },
    createVendor() {
      this.resetVendor();
      this.$router.push("/vendors/add");
    }
  }
};
</script>
